import { Box, Typography } from '@mui/material'

import RectangleButtonComponent from 'components/RectangleButton'

import GroupOfPeople from '../../assets/images/groupOfPeople.svg'
import { styles } from './CallToAction.styles'

export interface Props {
	'data-testid': string
	helperText?: string
	homeVariant?: boolean
}

export const CallToAction = ({
	'data-testid': dataTestId,
	homeVariant,
	helperText,
}: Props) => {
	return (
		<Box
			data-testid={`${dataTestId}__cta-container`}
			sx={{
				...styles.ctaContainer,
				...(homeVariant
					? { ...styles.ctaContainerHomeVariant }
					: { ...styles.ctaContainerNotHomeVariant }),
			}}
		>
			{homeVariant && (
				<img
					src={GroupOfPeople as unknown as string}
					style={styles.ctaImage}
				/>
			)}
			<Box
				sx={{
					...styles.ctaInnerContainer,
					...(homeVariant
						? { ...styles.ctaInnerContainerHomeVariant }
						: { ...styles.ctaInnerContainerNotHomeVariant }),
				}}
			>
				<Typography
					data-testid={`${dataTestId}__cta-text1`}
					sx={{
						...styles.callToActionText,
						...(homeVariant
							? { ...styles.callToActionTextHomeVariant }
							: { ...styles.callToActionTextNotHomeVariant }),
					}}
				>
					{helperText ?? 'Want help finding your next great idea?'}
				</Typography>
				<Typography
					data-testid={`${dataTestId}__cta-text2`}
					sx={{
						...styles.ctaCaption,
						...(homeVariant
							? { ...styles.ctaCaptionHomeVariant }
							: { ...styles.ctaCaptionNotHomeVariant }),
					}}
				>
					Schedule a live brainstorming session with expert
					facilitators.
				</Typography>

				<Box
					data-testid={`${dataTestId}__cta`}
					sx={{
						...styles.btnConnect,
						...(homeVariant
							? { ...styles.btnConnectHomeVariant }
							: { ...styles.btnConnectNotHomeVariant }),
					}}
				>
					<RectangleButtonComponent
						color="secondary"
						data-testid={`${dataTestId}__cta_button`}
						href={'https://go.slalom.com/brainstorm-support'}
						target="_blank"
						text={"LET'S CONNECT"}
						variant={homeVariant ? 'contained' : 'outlined'}
						sx={homeVariant ? {} : styles.ctaButton}
					/>
				</Box>
			</Box>
		</Box>
	)
}
